import { PropsWithClassName } from "../../../../models/props-with-class-name";
import Card, { CardProps } from "../../../Shared/Card/Card";

import styles from "./MetaCard.module.css";

type MetaCardProps = PropsWithClassName<{ compare?: boolean }> & CardProps;

const MetaCard = ({ compare, className, children, ...rest }: MetaCardProps) => {
  return (
    <Card
      className={`${styles.card} ${
        compare ? styles.compareStyle : ""
      } ${className} border-0`}
      {...rest}
    >
      {children}
    </Card>
  );
};

export default MetaCard;
